export default __webpack_public_path__ + "static/desk01-eaf2d97977703f065327bf910096bb57.png";